const binding = { modules: {}, dataActions: {} };

    (binding.modules['hei-scrollspy'] = {
        c: () => require('partner/modules/hei-scrollspy/hei-scrollspy.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hei-scrollspy',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hei-scrollspy'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|hei-scrollspy|hei-scrollspy'] = {
                c: () => require('partner/modules/hei-scrollspy/hei-scrollspy.view.tsx'),
                cn: '__local__-__local__-hei-scrollspy'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };